module.exports = require('./helpers/bundle-url').getBundleURL('1adP4') + "logo-dark.eefe0b7f.svg";